import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { adminInstance } from "../../config/axios";
import DeleteConfirmPopup from "../common/deleteConfirmPopup";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { getGiftCards } from "../../reducers/adminReducers";
import "../../assets/styles/admin.css";
import Loader from "../loader/loader";
import ListDatatable from "./listdatatable";

const GiftCard = () => {
  const result = useSelector((state) => state.admin);
  const { giftCardList, loginAdmin } = result || {};
  const { role } = loginAdmin || [];
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState();
  const [dummy, setDummy] = useState(false);
  const [loading, setLoading] = useState(false);
  const getAllGiftCardData = async () => {
    setLoading(true);
    const response = await dispatch(getGiftCards());
    if (response?.payload) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllGiftCardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, dummy]);
  const handleOnDelete = async (id) => {
    setDummy(false);
    try {
      setOpen(false);
      const response = await adminInstance().put(
        `api/admin/deleteGiftCard/${id}`,
      );
      setDummy(true);
      const { code } = response.data;
      if (code === 200) {
        toast.success("Successfully Deleted", { toastId: 1 });
      } else {
        setDummy(false);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onCloseModal = () => {
    setOpen(false);
  };
  return (
    <Fragment>
      <Breadcrumb title="Gift-Card List" parent="gift-card" />
      <Container fluid={true} className="index-page">
        <div className="admin-card">
          {/* {loderStatus && <Loader /> } */}
          <Card>
            <CardHeader>
              <h5>Gift Card</h5>
            </CardHeader>
            <CardBody>
              {role?.some((r) =>
                ["suUsers", "superAdmin", "writeCategory"].includes(r),
              ) && (
                <div className="btn-popup pull-right admin-category">
                  <Link
                    to="/add-gift-card"
                    className="btn btn-secondary main-btn">
                    Create Gift Card
                  </Link>
                </div>
              )}

              <div className="clearfix"></div>
              <div
                id="batchDelete"
                className="category-table user-list order-table coupon-list-delete">
                {!loading ? (
                  giftCardList && giftCardList.length > 0 ? (
                    <ListDatatable
                      multiSelectOption={false}
                      myData={giftCardList}
                      pageSize={10}
                      pagination={true}
                      class="-striped -highlight"
                      setActiveId={setActiveId}
                      setOpen={setOpen}
                    />
                  ) : (
                    <h1>Data does not found</h1>
                  )
                ) : (
                  <Loader />
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
      <DeleteConfirmPopup
        title={"Delete Category"}
        open={open}
        handleOnDelete={handleOnDelete}
        onCloseModal={onCloseModal}
        id={activeId}
      />
    </Fragment>
  );
};
export default GiftCard;
